import { IAccountMarketingPreferencesFormValues } from '@models/IAccountMarketingPreferences';
import axios from 'axios';

const accountMarketingPreferencesSubmit = async (
  apiUrl: string,
  formValues: IAccountMarketingPreferencesFormValues
) => {
  await axios.post(apiUrl, {
    ...formValues,
  });
};

export default accountMarketingPreferencesSubmit;
